// extracted by mini-css-extract-plugin
module.exports = {"skipNav":"SkipNav_skipNav__3f0el"};